var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomensHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000181769258744684069880000013942671255404728253_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000048477818969303586800000015199603446185394333_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135654947402350612820000004421217655436769165_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000135654947402350612820000004421217655436769165_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151516506075471702150000008024123458510244002_",
    x: 10,
    y: 7.3,
    width: 83.5,
    height: 83.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129176243473424934220000016919185414610074793_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151516506075471702150000008024123458510244002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129176243473424934220000016919185414610074793_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6,35.1c0-5.4-1.5-10.6-4.4-15.1c-2.9-4.5-7-8.1-11.9-10.3c-4.9-2.2-10.3-3-15.6-2.2c-5.3,0.8-10.3,3.1-14.3,6.6 s-6.9,8.2-8.4,13.3c-1.5,5.1-1.4,10.6,0.2,15.8c1.6,5.1,4.6,9.7,8.7,13.1c4.1,3.4,9.1,5.6,14.4,6.3v10.7h-7c-0.9,0-1.8,0.3-2.5,1 c-0.7,0.7-1,1.5-1,2.5c0,0.9,0.4,1.8,1,2.5c0.7,0.6,1.5,1,2.5,1h7v7c0,0.9,0.4,1.8,1,2.5c0.7,0.6,1.5,1,2.5,1c0.9,0,1.8-0.4,2.5-1 c0.7-0.7,1-1.6,1-2.5v-7h7c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1-1.6,1-2.5c0-0.9-0.4-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1h-7V62.7 c6.7-0.8,12.9-4.1,17.4-9.2C77.1,48.4,79.6,41.9,79.6,35.1z M30.9,35.1c0-4.1,1.2-8.2,3.5-11.6c2.3-3.4,5.6-6.1,9.4-7.7 c3.8-1.6,8-2,12.1-1.2c4,0.8,7.8,2.8,10.7,5.7c2.9,2.9,4.9,6.6,5.7,10.7c0.8,4,0.4,8.2-1.2,12.1c-1.6,3.8-4.3,7.1-7.7,9.4 c-3.4,2.3-7.5,3.5-11.6,3.5c-5.5,0-10.8-2.2-14.8-6.1C33.1,46,30.9,40.6,30.9,35.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomensHealth);
export default __webpack_public_path__ + "static/media/Womens-health.051de1f6e80ebbe89aec2565ba804bad.svg";
export { ForwardRef as ReactComponent };